import { svg } from "lit";
const icon = svg `<path d="M9.95192 17.6534L4.2981 11.9995L9.95192 6.3457L11.0057 7.4303L7.1865 11.2496H19.7019V12.7495H7.1865L11.0057 16.5688L9.95192 17.6534Z" fill="currentColor"/>`;
export default icon;
